import React__default from 'react';
import { useStepsContext } from './StepsContext.js';
import { useStepSizeContext } from './StepSizeContext.js';
import Box from '../Box/Box.js';

const StepLabel = ({
  isCurrentStep,
  opacity,
  label,
  description
}) => {
  const {
    isLabelVertical
  } = useStepsContext();
  const shouldRender = !!label || !!description;
  const {
    size
  } = useStepSizeContext();
  return shouldRender ? /*#__PURE__*/React__default.createElement(Box, {
    as: "div",
    "aria-current": isCurrentStep ? 'step' : undefined,
    sx: {
      textAlign: isLabelVertical ? 'center' : 'left',
      alignItems: isLabelVertical ? 'center' : 'flex-start',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    }
  }, !!label && /*#__PURE__*/React__default.createElement(Box, {
    as: "span",
    sx: {
      mx: isLabelVertical ? 0 : 2,
      mt: isLabelVertical ? 1 : 0,
      opacity,
      color: 'text.default',
      fontWeight: 'medium',
      textAlign: 'center',
      fontSize: size === 'sm' ? 2 : size === 'md' ? 3 : size === 'lg' ? 4 : 3
    }
  }, label), !!description && /*#__PURE__*/React__default.createElement(Box, {
    as: "span",
    sx: {
      mx: isLabelVertical ? 0 : 2,
      mt: isLabelVertical ? 2 : 0,
      opacity,
      color: 'text.subtle',
      marginTop: '-2px',
      textAlign: 'center',
      fontSize: size === 'sm' ? 1 : size === 'md' ? 2 : size === 'lg' ? 3 : 2
    }
  }, description)) : null;
};
StepLabel.displayName = 'StepLabel';

export { StepLabel };
